var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-header clearfix"},[_c('span',[_vm._v("课堂内外数字资源中心")]),_c('the-right-content',{staticClass:"float-right"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }